import React, { useEffect, useState } from 'react';
import './App.css';

const PUB = process.env.PUBLIC_URL;

const newsItems = [
  { date: 'Sep 2026', content: <>Organizing <span className="semibold"><a href="https://worldascanvas.github.io" target="_blank" rel="noopener noreferrer">The World as a Canvas</a></span>, a workshop on materializing imagination through prompting the physical world, at <a href="https://uist.acm.org/2026/" target="_blank" rel="noopener noreferrer">ACM UIST 2026</a> in Detroit.</> },
  { date: 'Apr 2026', content: <>Gave a guest lecture on "Social XR for a Connected Future" in the Computer and Society course at POSTECH, hosted by <a href="https://eunkyungjo.com/" target="_blank" rel="noopener noreferrer">Eunkyung Jo</a>.</> },
  { date: 'Feb 2026', content: <>Served as Posters AC for <a href="https://chi2026.acm.org/" target="_blank" rel="noopener noreferrer">ACM CHI 2026</a> and Reviewer for <a href="https://dis.acm.org/2026/" target="_blank" rel="noopener noreferrer">ACM DIS 2026</a>.</> },
  { date: 'Nov 2025', content: <>Gave an invited talk at National Yang Ming Chiao Tung University, hosted by <a href="https://www.armuro.info/" target="_blank" rel="noopener noreferrer">Yung-Ju (Stanley) Chang</a>.</> },
  { date: 'Oct 2025', content: <>Served as Program Committee for <a href="https://iui.acm.org/2026/" target="_blank" rel="noopener noreferrer">ACM IUI 2026</a>, and Reviewer for <a href="https://chi2026.acm.org/" target="_blank" rel="noopener noreferrer">ACM CHI 2026</a> & <a href="https://percom.org/" target="_blank" rel="noopener noreferrer">IEEE PerCom 2026</a>.</> },
  { date: 'Sep 2025', content: <>Attended back-to-back conferences: UIST and ISMAR in Korea.</> },
  { date: 'May 2025', content: <><span className="semibold"><a href="https://doi.org/10.1145/3746059.3747656" target="_blank" rel="noopener noreferrer">EmoShortcuts</a></span> was accepted to <a href="https://uist.acm.org/2025/" target="_blank" rel="noopener noreferrer">ACM UIST 2025</a>.</> },
  { date: 'Apr 2025', content: <>Attended <a href="https://chi2025.acm.org/" target="_blank" rel="noopener noreferrer">ACM CHI 2025</a>, presented at <a href="https://xr-and-ai.github.io/" target="_blank" rel="noopener noreferrer">EverydayAR Workshop</a> and served as a Session Chair for the first time.</> },
  { date: 'Apr 2025', content: <>Gave an invited talk at University of Tokyo, hosted by <a href="https://iis-lab.org/member/koji-yatani/" target="_blank" rel="noopener noreferrer">Koji Yatani</a>.</> },
  { date: 'Mar 2025', content: <>Served as a reviewer for <a href="https://dis.acm.org/2025/" target="_blank" rel="noopener noreferrer">ACM DIS 2025</a> and <a href="https://cc.acm.org/2025/" target="_blank" rel="noopener noreferrer">Creativity & Cognition 2025</a>.</> },
  { date: 'Feb 2025', content: <>Received an outstanding presentation award from <a href="https://2025winter.sigchi.kr/" target="_blank" rel="noopener noreferrer">Top Conference Session</a> at <a href="https://conference.hcikorea.org/hcik2025/main/main.asp" target="_blank" rel="noopener noreferrer">HCI Korea 2025</a>.</> },
  { date: 'Dec 2024', content: <>Served as a reviewer for <a href="https://www.ubicomp.org/ubicomp-iswc-2025/" target="_blank" rel="noopener noreferrer">ACM IMWUT 2025</a>.</> },
  { date: 'Oct 2024', content: <>Received <a href="https://buildyourfuture.withgoogle.com/" target="_blank" rel="noopener noreferrer">East Asia Student Travel Grants</a> from Google for UIST travel.</> },
  { date: 'Oct 2024', content: <>Presented my first paper, <span className="semibold"><a href="https://dl.acm.org/doi/10.1145/3654777.3676463" target="_blank" rel="noopener noreferrer">GradualReality</a></span>, at <a href="https://uist.acm.org/2024/" target="_blank" rel="noopener noreferrer">ACM UIST 2024</a>.</> },
  { date: 'Sep 2024', content: <>Started visiting research at <a href="https://www.smu.edu.sg/" target="_blank" rel="noopener noreferrer">Singapore Management University</a>, working with <a href="https://faculty.smu.edu.sg/profile/rajesh-krishna-balan-591" target="_blank" rel="noopener noreferrer">Rajesh Balan</a> and <a href="https://www.thivyak.info/" target="_blank" rel="noopener noreferrer">Thivya Kandappu</a>.</> },
  { date: 'Jul 2024', content: <>First first-author paper, <span className="semibold"><a href="https://dl.acm.org/doi/10.1145/3654777.3676463" target="_blank" rel="noopener noreferrer">GradualReality</a></span>, was accepted to UIST 2024.</> },
  { date: 'Jun 2024', content: <>Selected as a visiting research student at <a href="https://www.smu.edu.sg/" target="_blank" rel="noopener noreferrer">Singapore Management University</a>.</> },
  { date: 'Apr 2024', content: <>Submitted a paper to <a href="https://uist.acm.org/2024/" target="_blank" rel="noopener noreferrer">ACM UIST 2024</a> with co-author <a href="https://juheonyi.github.io/" target="_blank" rel="noopener noreferrer">Juheon Yi</a>.</> },
];

const publications = [
  {
    id: 'emoshortcuts',
    image: `${PUB}/images/EmoShortcuts_Preview.jpg`,
    title: 'EmoShortcuts: Emotionally Expressive Body Augmentation for Social Mixed Reality Avatar',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>,{' '}
        <a href="https://faculty.smu.edu.sg/profile/rajesh-krishna-balan-591" target="_blank" rel="noopener noreferrer">Rajesh Balan</a>,{' '}
        <a href="https://www.thivyak.info/" target="_blank" rel="noopener noreferrer">Thivya Kandappu</a>
      </>
    ),
    venue: 'ACM UIST 2025',
    links: [
      ['DOI', 'https://doi.org/10.1145/3746059.3747656'],
      ['PDF', `${PUB}/pdfs/EmoShortcuts(UIST2025).pdf`],
      ['Code', 'https://github.com/hyunaseo/EmoShortcuts'],
      ['Preview Video', 'https://youtu.be/kupnLM0QBkY'],
      ['Conference Talk', 'https://youtu.be/cnZ0w0Crf0c'],
    ],
  },
  {
    id: 'gradualreality',
    image: `${PUB}/images/GradualReality_Preview.jpg`,
    title: 'GradualReality: Enhancing Physical Object Interaction in Virtual Reality via Interaction State-Aware Blending',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://juheonyi.github.io/" target="_blank" rel="noopener noreferrer">Juheon Yi</a>,{' '}
        <a href="https://faculty.smu.edu.sg/profile/rajesh-krishna-balan-591" target="_blank" rel="noopener noreferrer">Rajesh Balan</a>,{' '}
        <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>
      </>
    ),
    venue: 'ACM UIST 2024',
    links: [
      ['DOI', 'https://dl.acm.org/doi/10.1145/3654777.3676463'],
      ['PDF', `${PUB}/pdfs/GradualReality(UIST2024).pdf`],
      ['Code', 'https://github.com/hyunaseo/GradualReality'],
      ['Demo', 'https://youtu.be/R0vnikegaKo?si=2jlC2twPCTttSDlb'],
      ['Conference Video', 'https://youtu.be/MpIXc-GUvLs?si=l52TB1ktbC2QHpTR'],
    ],
  },
];

// Workshops, posters, contests — card grid with first-page thumbnails.
const otherPublications = [
  {
    id: 'worldascanvas-uist26',
    conf: 'ACM UIST 2026',
    kind: 'Workshop',
    role: 'Organizer',
    thumb: `${PUB}/images/thumbs/worldascanvas.jpg`,
    title: 'The World as a Canvas: Materializing Imagination through Prompting the Physical World',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://nels.dev/" target="_blank" rel="noopener noreferrer">Nels Numan</a>,{' '}
        <a href="https://hyeyoungjo.com/" target="_blank" rel="noopener noreferrer">Hye-Young Jo</a>,{' '}
        <a href="https://jaewook-lee.com/" target="_blank" rel="noopener noreferrer">Jaewook Lee</a>,{' '}
        <a href="https://jonfroehlich.github.io/" target="_blank" rel="noopener noreferrer">Jon E. Froehlich</a>,{' '}
        <a href="https://duruofei.com/" target="_blank" rel="noopener noreferrer">Ruofei Du</a>,{' '}
        <a href="https://ryosuzuki.org/" target="_blank" rel="noopener noreferrer">Ryo Suzuki</a>,{' '}
        <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>
      </>
    ),
    links: [
      ['DOI', 'https://doi.org/10.1145/3830397.3842699'],
      ['PDF', `${PUB}/pdfs/WorldAsACanvas(UIST2026 Workshop).pdf`],
      ['Website', 'https://worldascanvas.github.io'],
    ],
  },
  {
    id: 'memoryreplay-uist26',
    conf: 'ACM UIST 2026',
    kind: 'Student Innovation Contest',
    thumb: `${PUB}/images/thumbs/memoryreplay.jpg`,
    title: 'MemoryReplay: Affective Playback of Captured Moments',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://kyungjin-lee.github.io" target="_blank" rel="noopener noreferrer">Kyungjin Lee</a>,{' '}
        <a href="https://juimdpp.github.io/" target="_blank" rel="noopener noreferrer">Hyunsoo Kim</a>,{' '}
        <a href="https://jingyulee.com" target="_blank" rel="noopener noreferrer">Jingyu Lee</a>
      </>
    ),
    links: [
      ['DOI', 'https://doi.org/10.1145/3830397.3841313'],
      ['PDF', `${PUB}/pdfs/MemoryReplay(UIST2026 SIC).pdf`],
    ],
  },
  {
    id: 'chi25-avatar',
    conf: 'ACM CHI 2025',
    kind: 'Workshop · Position Paper',
    thumb: `${PUB}/images/thumbs/chi25-avatar.jpg`,
    title: 'AI-Mediated Augmented Emotion Expression of Avatar for Social Mixed Reality',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>
      </>
    ),
    links: [
      ['PDF', `${PUB}/pdfs/AIMediatedAvatar(CHI2025 Workshop).pdf`],
      ['Workshop', 'https://xr-and-ai.github.io/'],
    ],
  },
  {
    id: 'live-mobisys22',
    conf: 'ACM MobiSys 2022',
    kind: 'Poster',
    thumb: `${PUB}/images/thumbs/live-mobisys22.jpg`,
    title: 'LIVE: Life-Immersive Virtual Environment with Physical Interaction-Aware Adaptive Blending',
    authors: (
      <>
        <span className="me">HyunA Seo</span>,{' '}
        <a href="https://juheonyi.github.io/" target="_blank" rel="noopener noreferrer">Juheon Yi</a>,{' '}
        <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>
      </>
    ),
    links: [
      ['DOI', 'https://doi.org/10.1145/3498361.3538769'],
      ['PDF', `${PUB}/pdfs/LIVE(MobiSys2022 Poster).pdf`],
    ],
  },
];

function useSeoulTime() {
  const [time, setTime] = useState('');
  useEffect(() => {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Seoul',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const id = setInterval(tick, 10000);
    return () => clearInterval(id);
  }, []);
  return time;
}


function ArrowLink({ href, children, external = true }) {
  const props = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <a className="arrow-link" href={href} {...props}>
      <span className="arrow-label">{children}</span>
      <span className="arrow-glyph" aria-hidden="true">↗</span>
    </a>
  );
}

function App() {
  const [showAllNews, setShowAllNews] = useState(false);
  const seoulTime = useSeoulTime();
  const displayedNews = showAllNews ? newsItems : newsItems.slice(0, 6);

  return (
    <div className="App">
      <header className="site-header">
        <div className="container site-header-inner">
          <span className="band band-header" aria-hidden="true" />
          <a href="#top" className="wordmark">HyunA Seo</a>
          <nav className="site-nav">
            <a href="#news">News</a>
            <a href="#publications">Publications</a>
            <a href={`${PUB}/CV_HyunA.pdf`} target="_blank" rel="noopener noreferrer">CV</a>
          </nav>
        </div>
      </header>

      <main id="top">
        {/* Hero */}
        <section className="section hero">
          <div className="container hero-container">
            <span className="band band-hero" aria-hidden="true" />
            <div className="hero-grid">
              <div className="hero-text">
                <h1 className="display">
                  <span className="display-layer">
                    Hi, I'm HyunA Seo<span className="dot">.</span>
                  </span>
                  <span className="display-layer display-knockout" aria-hidden="true">
                    Hi, I'm HyunA Seo.
                  </span>
                </h1>
                <p className="lede">
                  I'm a PhD student at <a href="https://hcs.snu.ac.kr/" target="_blank" rel="noopener noreferrer">Human-Centered Computing Systems Lab</a>, Seoul National University, under the guidance of <a href="https://youngkilee.blogspot.com/" target="_blank" rel="noopener noreferrer">Youngki Lee</a>.
                </p>
                <p>
                  I design eXtended Reality (XR) interactions and systems that integrate physical and digital experiences into everyday life. Everyday XR requires people to engage with the physical world while interacting with digital content, all within a limited attention span. My research explores how XR systems can support this balance by sensing users’ context and adapting when, where, and how digital content is presented in relation to the physical&nbsp;world.
                </p>
                <div className="hero-links">
                  <ArrowLink href="mailto:hyuna.seo@hcs.snu.ac.kr" external={false}>Email</ArrowLink>
                  <ArrowLink href="https://github.com/hyunaseo">GitHub</ArrowLink>
                  <ArrowLink href={`${PUB}/CV_HyunA.pdf`}>CV</ArrowLink>
                </div>
              </div>
              <figure className="hero-photo">
                <img src={`${PUB}/profile.jpg`} alt="HyunA Seo" />
              </figure>
            </div>
          </div>
        </section>

        {/* News */}
        <section className="section" id="news">
          <div className="container">
            <div className="section-head">
              <h2>Latest news.</h2>
            </div>
            <ul className="news-list">
              {displayedNews.map((item, index) => (
                <li className="news" key={`${item.date}-${index}`}>
                  <span className="news-date">{item.date}</span>
                  <span className="news-text">{item.content}</span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="arrow-link arrow-button"
              onClick={() => setShowAllNews((v) => !v)}
              aria-expanded={showAllNews}
            >
              <span className="arrow-label">{showAllNews ? 'Show less' : `Show all ${newsItems.length}`}</span>
              <span className="arrow-glyph" aria-hidden="true">{showAllNews ? '↑' : '↓'}</span>
            </button>
          </div>
        </section>
        {/* Publications */}
        <section className="section" id="publications">
          <div className="container">
            <div className="section-head">
              <h2>Selected publications.</h2>
            </div>
            <ol className="pub-list">
              {publications.map((p) => (
                <li className="pub" key={p.id}>
                  <div className="pub-figure">
                    <div className="pub-venue">{p.venue}</div>
                    <a className="pub-image" href={p.links[0][1]} target="_blank" rel="noopener noreferrer" tabIndex={-1} aria-hidden="true">
                      <img src={p.image} alt="" />
                    </a>
                  </div>
                  <div className="pub-body">
                    <h3 className="pub-title">
                      <a href={p.links[0][1]} target="_blank" rel="noopener noreferrer">{p.title}</a>
                    </h3>
                    <p className="pub-authors">{p.authors}</p>
                    <div className="pub-links">
                      {p.links.map(([label, href]) => (
                        <ArrowLink key={label} href={href}>{label}</ArrowLink>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ol>

            <div className="pub-other">
              <h3 className="pub-other-title">Workshops, posters &amp; contests</h3>
              <ul className="pub-grid">
                {otherPublications.map((p) => (
                  <li className="card" key={p.id}>
                    <a className="card-thumb" href={p.links[0][1]} target="_blank" rel="noopener noreferrer" tabIndex={-1} aria-hidden="true">
                      {p.thumb ? (
                        <img src={p.thumb} alt="" loading="lazy" />
                      ) : (
                        <span className="card-thumb-empty">{p.conf}</span>
                      )}
                    </a>
                    <div className="card-venue">
                      <span className="card-conf">{p.conf}</span>
                      <span className="card-kind">
                        {p.kind}
                        {p.role && <span className="card-role">{p.role}</span>}
                      </span>
                    </div>
                    <h4 className="card-title">
                      <a href={p.links[0][1]} target="_blank" rel="noopener noreferrer">{p.title}</a>
                    </h4>
                    <p className="card-authors">{p.authors}</p>
                    <div className="card-links">
                      {p.links.map(([label, href]) => (
                        <ArrowLink key={label} href={href}>{label}</ArrowLink>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

      </main>

      {/* Contact + footer: one full-bleed blue block */}
      <footer className="contact" id="contact">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-main">
              <h2>Let's talk about everyday XR.</h2>
              <a className="contact-mail" href="mailto:hyuna.seo@hcs.snu.ac.kr">hyuna.seo@hcs.snu.ac.kr</a>
            </div>
            <div className="contact-meta">
              <span>Human-Centered Computing Systems Lab</span>
              <span>Seoul National University</span>
              <a href="https://github.com/hyunaseo" target="_blank" rel="noopener noreferrer">github.com/hyunaseo</a>
            </div>
          </div>
          <div className="contact-foot">
            <span className="footer-left">
              <span className="footer-name">HyunA Seo</span>
              <span>© {new Date().getFullYear()}</span>
            </span>
            <span className="footer-right">
              <span className="status">
                <span className="status-square" aria-hidden="true" />
                Seoul
              </span>
              {seoulTime && <span className="status-time">{seoulTime} KST</span>}
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
